import { LogoMark } from './Logo';
import { SYSTEMS } from '../systems';
import { useStore, show, updateSysUI } from '../store';

const NAV = [
  ['chat', 'Komut merkezi', <path d="M4 5h16v11H8l-4 4z" />],
  ['approvals', 'Onaylar', <><circle cx="12" cy="12" r="8.5" /><path d="M8.5 12.2l2.4 2.4 4.6-5" /></>],
  ['quotes', 'Teklifler', <><path d="M7 3h7l4 4v14H7z" /><path d="M14 3v4h4M10 12h5M10 16h5" /></>],
  ['systems', 'Bağlı sistemler', <><rect x="3" y="4" width="18" height="12" rx="1.5" /><path d="M8 20h8M12 16v4" /></>],
  ['audit', 'Denetim', <path d="M5 20V10M11 20V4M17 20v-7" />]
];

export function NavButtons() {
  const { view, pending, quotes } = useStore();
  return NAV.map(([id, label, icon]) => (
    <button key={id} className={'nav-btn' + (view === id ? ' active' : '')} onClick={() => show(id)}>
      <svg viewBox="0 0 24 24">{icon}</svg>
      <span>{label}</span>
      <span className="count" style={id === 'quotes' ? { background: 'var(--ink)' } : undefined}>
        {id === 'approvals' ? pending.length || '' : id === 'quotes' ? quotes.length || '' : ''}
      </span>
    </button>
  ));
}

export function Sidebar() {
  const { pulse } = useStore();
  return (
    <aside>
      <div className="logo">
        <LogoMark />
        <div><div className="logo-word">VİZOVA</div><div className="logo-sub">Operasyon asistanı</div></div>
      </div>
      <div className="company"><b>Anadolu Makina A.Ş.</b><span>Said Berk · Satış operasyon</span></div>
      <nav id="nav"><NavButtons /></nav>
      <div className="systems">
        <h4>Bağlı sistemler</h4>
        <div id="sysSide">
          {SYSTEMS.map(s => (
            <div key={s.id} className="sys" style={{ cursor: 'pointer' }}
              onClick={() => { show('systems'); updateSysUI({ open: s.id, path: [], erpTab: 0, tick: Date.now() }); }}>
              <i className={pulse[s.id] ? 'pulse' : undefined}></i>
              <span>{s.name}</span>
              <em>{s.kind === 'erp' ? 'ERP' : s.dept}</em>
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
}

export function MobileHead() {
  return (
    <div className="m-head">
      <div className="m-top">
        <div className="logo">
          <LogoMark />
          <div className="logo-word">VİZOVA</div>
        </div>
        <div className="m-sys"><i></i>6 sistem bağlı</div>
      </div>
      <div className="m-tabs" id="mnav"><NavButtons /></div>
    </div>
  );
}
